import Text from '../shared-components/Text';
import Title from '../shared-components/Title';
import styles from './AboutMe.module.css';
import React from 'react';

function AboutMe() {
  return (
    <div className={styles.aboutmeTop}>
      <Title className={styles.title} title="About Me" />
      {/* <Title title="About me" /> */}
      <div className={styles.aboutMe}>
        {/* <img
          className={styles.myFace}
          src="me-linked.jpeg"
          alt="A picture of what I look like. "
        /> */}
        <div className={styles.textContainer}>
          <div className={styles.titleContainer}>
            {/* <img
              className={styles.awsLogo}
              src="AWS-cloud-logo.png"
              alt="AWS CCP cert logo"
            /> */}
          </div>
          <Text
            text={` I’ve spent the past four
            years building and designing software at scale, taking on
            senior-level responsibilities like leading architecture decisions
            and mentoring teammates. I bring a strong foundation of engineering
            principles, problem-solving, and system thinking to every project I
            work on. I am software language agnostic, but I work mostly with
            Python, TypeScript, and React, with a preference for backend
            development. I care deeply about writing clean code, documenting
            projects for the future engineer, following test driven development
            (TDD), and building things that last.`}
          />
          <Text
            text={`            Outside of work, I tinker with 3D printing, photography, and taking
            hikes.`}
          />
        </div>
      </div>
      {/* <div className={styles.githubContainer}>
        <GitHubButton />
      </div> */}
    </div>
  );
}

export default AboutMe;
